import $ from 'jquery';

import constants from './constants';

const elementClassNameAdded = 'js-math',
    mathContentRegexp = [
        { r: /\\\[([\s\S]*)\\\]/, inline: false, correct: true },
        { r: /\\\(([\s\S]*)\\\)/, inline: true, correct: true },
        { r: /\$\$\\\[([\s\S]*)\\\]\$\$/, inline: false },
        { r: /\$\$\\\(([\s\S]*)\\\)\$\$/, inline: true },
        { r: /^[$][$]([^$]+)[$][$]/, inline: true },
        { r: /^[$]([^$]+)[$]/, inline: true },
    ];

const cleanMathTags = {
    cleanElement(elements) {
        const $maths = $(elements),
            newElements = [];

        $maths.each(function (n, element) {
            const $element = $(element);
            let $newCreatedElement;

            if (!cleanMathTags.isCleanElement($element)) {
                $newCreatedElement = normalizeElement($element);
                newElements.push($newCreatedElement.get(0));
            }
        });

        return (newElements.length === 0) ? $maths : $(newElements);
    },

    revert(element) {
        $(element).each(function (n, elm) {
            const $elm = $(elm);
            let $parent = $elm.parent();
            const parentWasChangedTagName = $parent.attr('data-was-changed');

            if (parentWasChangedTagName) {
                $parent = changeTagName($parent, parentWasChangedTagName);
                $parent.removeAttr('data-was-changed');
            }

            $elm.removeClass('js-math math-formula');
        });
    },

    isCleanElement($element) {
        if ($element.is('math') || !$element.hasClass(elementClassNameAdded)) {
            return false;
        }

        return mathContentRegexp.every(regexpConf => regexpConf.correct || !$element.text().match(regexpConf.r));
    },
};

function normalizeElement($element) {
    const tagName = $element.get(0).tagName,
        isInline = getInlineModeFromContentElement($element),
        correctTag = isInline ? 'SPAN' : 'DIV';

    let $newElement = $element;

    if (tagName !== correctTag) {
        $newElement = $(`<${correctTag}>`);
        $element.replaceWith($newElement);
    }

    $newElement.text(getValidContent($element));

    const $parent = $newElement.parent();
    const parent = $parent[0];

    if (!isInline && parent && (['P', 'SPAN'].indexOf(parent.tagName) >= 0)) {
        changeTagName($parent, 'DIV', true);
    }

    return $newElement;
}

function getValidContent($element) {
    const content = getLatexFromContentElement($element),
        isInline = getInlineModeFromContentElement($element),
        wrapper = isInline ? constants.MATH_TEXT_WRAPPERS_INLINE : constants.MATH_TEXT_WRAPPERS_BLOCK;

    return wrapper[0] + content + wrapper[1];
}

function getInlineModeFromContentElement($element) {
    const content = $element.text();

    const isInline = mathContentRegexp.reduce((isInline, regexpConf) => {
        if (isInline === null && content.match(regexpConf.r)) {
            return regexpConf.inline;
        }

        return isInline;
    }, null);

    return isInline === null ? true : isInline;
}

function getLatexFromContentElement($element) {
    const content = $element.text();

    const latexContent = mathContentRegexp.reduce((latexContent, regexpConf) => {
        if (latexContent) {
            return latexContent;
        }

        const match = content.match(regexpConf.r);

        return match ? match[1] : latexContent;
    }, null) || content;

    return latexContent;
}

function changeTagName($parentElement, newTagName, flagNewElement) {
    const parentElement = $parentElement[0],
        parentElementTagName = parentElement.tagName,
        attrs = Array.prototype.slice.call(parentElement.attributes),
        $newElement = $(`<${newTagName}>`);

    // copy all attributes
    attrs.forEach((attr) => { $newElement.attr(attr.name, attr.value); });

    const $contents = $parentElement.contents();

    $newElement.append($contents);

    if (flagNewElement) {
        $newElement.attr('data-was-changed', parentElementTagName);
    }

    $parentElement.replaceWith($newElement);

    return $newElement;
}

export default cleanMathTags;
